import React from "react";
import { Sparkles, Clock, ShieldCheck, BadgePercent, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { WHATSAPP_URL } from "../mock";

const Pill = ({ Icon, children }) => (
  <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-[12.5px] text-slate-200">
    <Icon className="h-3.5 w-3.5 text-amber-400" />
    {children}
  </div>
);

const MidCTA = () => {
  return (
    <section className="px-4 md:px-6 -mt-2 md:-mt-4">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl border border-amber-500/25 bg-gradient-to-br from-amber-500/[0.08] via-[#0e1626] to-red-500/[0.06] p-6 md:p-10">
          <div className="absolute -top-16 -right-16 h-64 w-64 rounded-full bg-amber-500/10 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-16 -left-16 h-64 w-64 rounded-full bg-red-500/10 blur-3xl pointer-events-none" />

          <div className="relative grid md:grid-cols-[1.2fr_1fr] gap-7 md:gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-red-500/15 border border-red-500/30 px-3 py-1 text-red-300 text-[10.5px] tracking-[0.18em] uppercase font-semibold">
                <span className="h-1.5 w-1.5 rounded-full bg-red-400 animate-pulse" />
                Spots filling for next intake
              </span>
              <h3 className="mt-4 text-white text-[26px] md:text-[36px] font-semibold leading-[1.1] tracking-tight">
                Don't let your <span className="text-amber-400">exam fee</span> go to waste.
              </h3>
              <p className="mt-3 text-slate-300 text-[14.5px] md:text-[15.5px] leading-relaxed max-w-xl">
                Apply free in under 2 minutes. A counsellor will confirm your cashback eligibility on WhatsApp —
                <span className="text-white font-medium"> usually within an hour</span> during business time.
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                <Pill Icon={Clock}>2-min form</Pill>
                <Pill Icon={ShieldCheck}>No fees, no obligation</Pill>
                <Pill Icon={BadgePercent}>93% visa success</Pill>
              </div>
            </div>
            <div className="flex flex-col gap-3 md:items-end">
              <Button
                asChild
                className="h-12 px-6 rounded-full bg-red-500 hover:bg-red-600 text-white text-[14.5px] font-semibold shadow-lg shadow-red-500/30"
              >
                <a href="#apply" className="inline-flex items-center gap-2">
                  <Sparkles className="h-4 w-4" /> Get Cashback
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="h-12 px-6 rounded-full bg-transparent border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 hover:text-emerald-200 text-[14.5px]"
              >
                <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2">
                  <MessageCircle className="h-4 w-4" /> Chat on WhatsApp instead
                </a>
              </Button>
              <div className="text-slate-400 text-[12px] md:text-right">No spam · Your details stay private</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidCTA;
